import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="rounded-full p-1.5 hover:bg-secondary"><ArrowLeft className="h-5 w-5" /></button>
        <h1 className="font-display text-xl font-extrabold">Privacy Policy</h1>
      </div>
      <div className="prose prose-sm mt-6 max-w-none space-y-4 text-sm leading-relaxed text-foreground/80">
        <p>Venda Market ("we", "us") respects your privacy. This policy explains what we collect and how we use it.</p>
        <h2 className="font-semibold text-foreground">Information we collect</h2>
        <p>We collect the details you provide when creating an account (name, email, phone, date of birth), the listings you post, messages you send, and any identity documents you submit for seller verification.</p>
        <h2 className="font-semibold text-foreground">How we use it</h2>
        <p>Your information is used to operate the marketplace: showing your listings, connecting buyers and sellers, verifying identities, preventing fraud, and sending you relevant notifications.</p>
        <h2 className="font-semibold text-foreground">Sharing</h2>
        <p>Your name, location and listings are visible to other users. Your phone number is only shown to signed-in users so buyers can contact you. Your email and identity documents are never shown publicly.</p>
        <h2 className="font-semibold text-foreground">Your choices</h2>
        <p>You can edit your profile, control notifications, and delete your account at any time. Deleted accounts enter a 30-day grace period before permanent removal.</p>
        <h2 className="font-semibold text-foreground">Safety</h2>
        <p>Never pay before physically viewing an item. Venda Market is not liable for transactions between users. Always meet in safe, public places.</p>
        <h2 className="font-semibold text-foreground">Contact</h2>
        <p>Questions? Reach us at support@vendamarket.com.</p>
      </div>
    </div>
  );
}
